<script>
  import { onMount } from 'svelte';
  import { fetchFeeds } from '../../../Api/ntbApi';
  import { selectedChannelId } from '../../../Store/feeds-store';
  import EditInput from '../../Common/EditInput/EditInput.svelte';
  import {
    updateChannelFeedId,
    listenToChannel,
    updateScribbleChannel,
  } from '../../../Api/messagesApi';
  let feeds = [];
  let selectedItem;
  let selectedFeed;

  $: $selectedChannelId && getChannelData();

  onMount(async () => {
    const res = await fetchFeeds();
    if (res) {
      feeds = res._items;
    }
    findSelectedItem();
  });

  const getChannelData = async () => {
    await listenToChannel($selectedChannelId, (snapShot) => {
      if (snapShot.exists) {
        selectedFeed = { ...snapShot.data(), id: snapShot.id };
      }
    });
  };

  const onSelectedFeedClicked = async (index) => {
    if (!selectedFeed.live && !selectedFeed.scribbleChannel) {
      await updateChannelFeedId(selectedFeed.id, feeds[index]._id);
      findSelectedItem();
    }
  };

  const onCancelFeedClicked = async (e) => {
    e.stopPropagation();
    if (!selectedFeed.live && !selectedFeed.scribbleChannel) {
      await updateChannelFeedId(selectedFeed.id, '');
      selectedFeed.feedId = '';
      findSelectedItem();
    }
  };

  const findSelectedItem = () => {
    selectedItem = feeds.find((item) => item._id === selectedFeed.feedId);
  };

  const onSaveScribbleChannel = async (e) => {
    if (e) {
      await updateScribbleChannel($selectedChannelId, e.detail);
    }
  };
</script>

{#if feeds.length}
  <div class="feeds-container">
    <div class="scribble-header">
      <h4>Skriv inn en Scribble kanal</h4>
      <EditInput
        disabled={selectedFeed.live || selectedFeed.feedId}
        value={selectedFeed.scribbleChannel || ''}
        on:save={onSaveScribbleChannel}
        large={true}
      />
    </div>
    <div class="header">
      <h4>Velg en NTB kanal</h4>
    </div>
    <ul class="feeds-list" class:disabled={selectedFeed.live || selectedFeed.scribbleChannel}>
      {#each feeds as feed, index}
        <li
          class="url"
          class:selected={selectedFeed.feedId === feed._id}
          on:click={() => onSelectedFeedClicked(index)}
        >
          <p>
            {feed.title}
            {#if selectedFeed.feedId === feed._id && selectedItem?.description}
              <div class="selected-feed">
                <span>Merknad: {selectedItem.description}</span>
              </div>
            {/if}
          </p>
          <div class="btn-container">
            {#if selectedFeed.feedId === feed._id}
              <button class="icon-button" on:click={onCancelFeedClicked}>
                <span class="material-icons"> cancel </span>
              </button>
            {/if}
          </div>
        </li>
      {/each}
    </ul>
  </div>
{/if}

<style src="./feeds.scss">
</style>
